var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agent-profiles"},_vm._l((_vm.listing.Agents),function(agent){return _c('div',{key:agent.Id},[_c('ProfileCard',{attrs:{"profile":agent}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }